import axios from "axios";
import Configuration from "@common/Configuration";

// Home Realm Discovery: dato un identificativo di login, il backend risolve i
// realm (macro-clienti) presso cui autenticarsi. Endpoint pubblico (pre-login),
// quindi axios raw come MeService (nessun interceptor Bearer).
//
// Passa da VITE_CONFIG_API_BASE come ogni altra chiamata: in dev punta al backend
// (:8080/auth/discovery), in prod è `/api` → l'edge nginx instrada /api/auth/discovery
// (rate-limited, anti-enumeration) al backend. Nessun path cablato.

export type DiscoveryMatch = {
  customerName: string;
  realm: string;
  authority: string;
};

export async function discover(login: string): Promise<DiscoveryMatch[]> {
  const baseUrl = String(Configuration.VITE_CONFIG_API_BASE ?? "");
  const res = await axios.get<{ matches: DiscoveryMatch[] }>(`${baseUrl}/auth/discovery`, {
    params: { login },
  });
  return res.data?.matches ?? [];
}
